import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { skip } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BooleanSelectionService {

  constructor() { }
  private subject = new Subject<any>();

  onSelectionChange(data): void {
    this.subject.next(data);
  }

  booleanSelectionServiceSubscription(): Observable<any> {
    return this.subject.asObservable();
  }
}
